import configurationKeys from "queryKeyFactory/configurationKeys";
import { useQuery } from "react-query";
import { getIdleTimerConfig } from "services/configuration-service";
import { IdleTimerConfig } from "types/configuration";


export default function useGetIdleTimerConfig() {
    return useQuery<any, Error, IdleTimerConfig>(configurationKeys.idleTimerConfig, getIdleTimerConfig, {
        select: (res) => res.data,
        refetchOnWindowFocus: false,
    })
}